import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { SessionService } from 'src/app/services/storage/session.service';
import { ToastService } from 'src/app/services/toast.service';

import { BasePaths } from 'src/app/constants/routes';
import { ToastType } from 'src/app/constants/toast-type';

@Injectable()
export class AgentSessionGuard implements CanActivate {
    constructor(
        private sessionService: SessionService,
        private toastService: ToastService,
        private router: Router,
    ){
    }

    public canActivate(): Observable<boolean> {
        if (!this.sessionService.session.agent && this.router.url != BasePaths.VersionError) {
            this.toastService.buildToastMessage(ToastType.warning, 'Access Denied', 'Please log in again to access account!');
            this.router.navigateByUrl(BasePaths.Counselors);
        }

        return of(this.sessionService.session.isLoggedIn);
    }
}